/**
 * Wild Workouts trainer
 * TODO
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Hour model module.
 * @module model/Hour
 * @version 1.0.0
 */
class Hour {
    /**
     * Constructs a new <code>Hour</code>.
     * @alias module:model/Hour
     * @param hour {Date} 
     * @param available {Boolean} 
     * @param hasTrainingScheduled {Boolean} 
     */
    constructor(hour, available, hasTrainingScheduled) { 
        
        Hour.initialize(this, hour, available, hasTrainingScheduled);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, hour, available, hasTrainingScheduled) { 
        obj['hour'] = hour;
        obj['available'] = available;
        obj['hasTrainingScheduled'] = hasTrainingScheduled;
    }

    /**
     * Constructs a <code>Hour</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Hour} obj Optional instance to populate.
     * @return {module:model/Hour} The populated <code>Hour</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Hour();

            if (data.hasOwnProperty('hour')) {
                obj['hour'] = ApiClient.convertToType(data['hour'], 'Date');
            }
            if (data.hasOwnProperty('available')) {
                obj['available'] = ApiClient.convertToType(data['available'], 'Boolean');
            }
            if (data.hasOwnProperty('hasTrainingScheduled')) {
                obj['hasTrainingScheduled'] = ApiClient.convertToType(data['hasTrainingScheduled'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Date} hour
 */
Hour.prototype['hour'] = undefined;

/**
 * @member {Boolean} available
 */
Hour.prototype['available'] = undefined;

/**
 * @member {Boolean} hasTrainingScheduled
 */
Hour.prototype['hasTrainingScheduled'] = undefined;






export default Hour;

